export default __webpack_public_path__ + "6e878916b9be0a65fed02cc6946f5a36.png";